import {Component} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {CHART_TYPE} from '../../DoraData/data-base';
import {ChartTypeElement} from './Data/chart-type-element';
import {MessageChartType} from '../../messages/message-chart-type';
import {DoraProperty} from '../../Decorators/Decorator';

@Component({
  selector: 'dora-chart-type-setting',
  template: ''
})
/**
 * Base widget
 */
export class DoraChartTypeSettingComponent extends WidgetBaseComponent {
  // Flag enable type
  @DoraProperty
  protected flLinearEnabled = true;
  @DoraProperty
  protected flSpinEnabled = false;
  @DoraProperty
  protected flColumnEnabled = true;
  @DoraProperty
  protected flColumnStackEnabled = true;
  @DoraProperty
  protected flBarEnabled = true;
  @DoraProperty
  protected flPieEnabled = true;

  protected chartTypeElements: ChartTypeElement[] = [];
  @DoraProperty
  private defaultType = 'LINEAR';

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    // create element
    if (this.flLinearEnabled) {
        this.chartTypeElements.push(new ChartTypeElement(CHART_TYPE.LINEAR, CHART_TYPE[CHART_TYPE.LINEAR]));
    }
    if (this.flSpinEnabled) {
        this.chartTypeElements.push(new ChartTypeElement(CHART_TYPE.SPLINE, CHART_TYPE[CHART_TYPE.SPLINE]));
    }
    if (this.flColumnEnabled) {
        this.chartTypeElements.push(new ChartTypeElement(CHART_TYPE.COLUMN, CHART_TYPE[CHART_TYPE.COLUMN]));
    }
    if (this.flColumnStackEnabled) {
        this.chartTypeElements.push(new ChartTypeElement(CHART_TYPE.COLUMNSTACK, CHART_TYPE[CHART_TYPE.COLUMNSTACK]));
    }
    if (this.flBarEnabled) {
      this.chartTypeElements.push(new ChartTypeElement(CHART_TYPE.BAR, CHART_TYPE[CHART_TYPE.BAR]));
    }
    if (this.flPieEnabled) {
      this.chartTypeElements.push(new ChartTypeElement(CHART_TYPE.PIE, CHART_TYPE[CHART_TYPE.PIE]));
    }

    const typedDefaultChartType: CHART_TYPE = CHART_TYPE[this.defaultType.toUpperCase()];


    if (typedDefaultChartType === undefined) {
      console.error('CHART_TYPE ' + this.defaultType + ' not allowed');
      return;
    }

    this.activeChartType(typedDefaultChartType);
  }

  protected activeChartType(type2activate: CHART_TYPE): void {
    this.chartTypeElements.forEach((chartTypeElement) => {
      if (chartTypeElement.Type === type2activate) {
        chartTypeElement.FlActive = true;

        // fire event
        this.messageService.sendMessage(this.EventChannel, new MessageChartType(type2activate), this.CallerName);
      } else {
        chartTypeElement.FlActive = false;
      }
    });
  }
}
